import { Routes } from '@angular/router';

import { LandingPageComponent } from './landing-page/landing-page.component';
import { LandingPageResolverService } from './landing-page/landing-page.resolver';

export const routes: Routes = [
  {
    path: 'share-click',
    pathMatch: 'full',
    loadComponent: () => import('./share-click/share-click.component').then(module => module.ShareClickComponent),
  },
  {
    path: 'share-complete',
    pathMatch: 'full',
    loadComponent: () => import('./share-complete/share-complete.component').then(module => module.ShareCompleteComponent),
  },
  {
    path: 'accept-invite',
    loadComponent: () => import('./accept-invite/accept-invite.component').then(module => module.AcceptInviteComponent),
    pathMatch: 'full',
  },
  {
    path: 'v1/app/accept-invite',
    loadComponent: () => import('./accept-invite/accept-invite.component').then(module => module.AcceptInviteComponent),
    pathMatch: 'full',
  },
  {
    path: 'error',
    loadComponent: () => import('./error-page/error-page.component').then(module => module.ErrorPageComponent),
    pathMatch: 'full',
  },
  {
    path: 'inactive',
    loadComponent: () => import('./inactive-page/inactive-page.component').then(module => module.InactivePageComponent),
    pathMatch: 'full',
  },
  {
    path: ':campaignId',
    pathMatch: 'full',
    component: LandingPageComponent,
    resolve: {
      campaignData: LandingPageResolverService,
    },
  },
  {
    path: ':campaignId/stats',
    pathMatch: 'full',
    component: LandingPageComponent,
    resolve: {
      campaignData: LandingPageResolverService,
    },
  },
  {
    path: ':campaignId/:campaignParticipantId',
    pathMatch: 'full',
    component: LandingPageComponent,
    resolve: {
      campaignData: LandingPageResolverService,
    },
  },
  {
    path: ':campaignId/:campaignParticipantId/stats',
    pathMatch: 'full',
    component: LandingPageComponent,
    resolve: {
      campaignData: LandingPageResolverService,
    },
  },
  {
    path: '**',
    component: LandingPageComponent,
    resolve: {
      campaignData: LandingPageResolverService,
    },
    pathMatch: 'full',
  },
];
